const tallName = (value: unknown): boolean => /terminal|hangar/i.test(String(value ?? ""));

function insideRing(point: number[], ring: number[][]): boolean {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const a = ring[i],
      b = ring[j];
    if (a[1] > point[1] !== b[1] > point[1] && point[0] < ((b[0] - a[0]) * (point[1] - a[1])) / (b[1] - a[1]) + a[0])
      inside = !inside;
  }
  return inside;
}

/** Existing packs encode miscellaneous building types by their distinct fill styles. */
export function setAirportBuildingHeights(features: GeoJSON.Feature[]): void {
  const labels = features.filter(
    (f) => f.properties?._objType === 14 && f.geometry.type === "Point" && tallName(f.properties.text)
  );
  for (const feature of features) {
    const p = feature.properties;
    if (!p || p._objType !== 14 || !["Polygon", "MultiPolygon"].includes(feature.geometry.type)) continue;
    const kind = String(p.miscType ?? p.type ?? "").toLowerCase();
    const fill = String(p.fillColor ?? "").replace(/\s/g, "");
    if (
      !["building", "building secondary", "secondary building"].includes(kind) &&
      !["rgba(48,48,48,1)", "rgba(128,128,128,1)"].includes(fill)
    )
      continue;
    const polygons =
      feature.geometry.type === "Polygon"
        ? [feature.geometry.coordinates]
        : (feature.geometry as GeoJSON.MultiPolygon).coordinates;
    const tall =
      tallName(p.name ?? p.text) ||
      labels.some((label) => {
        const point = (label.geometry as GeoJSON.Point).coordinates;
        return polygons.some(
          (rings) => insideRing(point, rings[0]) && !rings.slice(1).some((hole) => insideRing(point, hole))
        );
      });
    p.airportBuildingHeightM = tall ? 15 : 10;
  }
}
